export default __webpack_public_path__ + "static/WFH-fallback-cae406c16a00834c0b242470aafd5cad.png";